<template>
    <app-layout>
        <template #header>
            <div class="pr-4 sm:flex items-center justify-between">
                <div class="flex">
                    <svg
                        xmlns="http://www.w3.org/2000/svg"
                        fill="none"
                        viewBox="0 0 24 24"
                        stroke-width="1.5"
                        stroke="currentColor"
                        width="30"
                        height="30"
                    >
                        <path
                            stroke="url(#paint0_linear_68_19)"
                            stroke-width="1.8"
                            stroke-linecap="round"
                            stroke-linejoin="round"
                            d="M4.098 19.902a3.75 3.75 0 0 0 5.304 0l6.401-6.402M6.75 21A3.75 3.75 0 0 1 3 17.25V4.125C3 3.504 3.504 3 4.125 3h5.25c.621 0 1.125.504 1.125 1.125v4.072M6.75 21a3.75 3.75 0 0 0 3.75-3.75V8.197M6.75 21h13.125c.621 0 1.125-.504 1.125-1.125v-5.25c0-.621-.504-1.125-1.125-1.125h-4.072M10.5 8.197l2.88-2.88c.438-.439 1.15-.439 1.59 0l3.712 3.713c.44.44.44 1.152 0 1.59l-2.879 2.88M6.75 17.25h.008v.008H6.75v-.008Z"
                        />

                        <defs>
                            <linearGradient
                                id="paint0_linear_68_19"
                                x1="4.56256"
                                y1="4.33394"
                                x2="24.9101"
                                y2="26.2819"
                                gradientUnits="userSpaceOnUse"
                            >
                                <stop stop-color="#FF8D47" />
                                <stop offset="0.147634" stop-color="#FF7447" />
                                <stop offset="0.454086" stop-color="#FF4247" />
                                <stop offset="0.636926" stop-color="#E92A5B" />
                                <stop offset="0.740367" stop-color="#DD1C67" />
                                <stop offset="0.842991" stop-color="#D31071" />
                                <stop offset="1" stop-color="#CF0283" />
                            </linearGradient>
                        </defs>
                    </svg>

                    <div class="ml-4">
                        <h2
                            class="text-xl font-semibold leading-tight tracking-tight sm:text-2xl text-[#18181B]"
                        >
                            {{
                                appearance
                                    ? $t("appearances.edit.title")
                                    : $t("appearances.create.title")
                            }}
                        </h2>
                        <p
                            class="inter text-sm font-medium mt-[2px] text-[#70707B]"
                        >
                            {{
                                appearance
                                    ? $t("appearances.edit.description")
                                    : $t("appearances.create.description")
                            }}
                        </p>
                    </div>
                </div>
            </div>
        </template>

        <div class="px-10 pt-8">
            <div class="mt-6 gap-y-4 grid grid-cols-12">
                <div class="col-span-12 flex flex-col items-start justify-end">
                    <label class="text-sm font-medium text-iron-700 block">
                        {{ $t("appearances.create.name") }}
                    </label>
                    <input
                        v-model="name"
                        type="text"
                        class="rounded-md sm:text-sm block w-full"
                        :class="[
                            'border-iron-300 text-iron-900 shadow-sm focus:border-z-orange-500 focus:ring-z-orange-500',
                        ]"
                    />
                </div>

                <div class="col-span-12 flex flex-col items-end justify-end">
                    <AddButton
                        data-cy="create-new-availability"
                        @click="handle"
                    >
                        {{
                            appearance
                                ? $t("appearances.edit.edit")
                                : $t("appearances.create.create")
                        }}
                    </AddButton>
                </div>
            </div>
        </div>
    </app-layout>
</template>

<script setup lang="ts">
import AppLayout from "../../../../Layouts/AppLayout.vue";
import AddButton from "../Atomic/AddButton.vue";
import { router } from "@inertiajs/vue3";
import { IAppearance } from "@/types/IAppearance";
import route from "ziggy-js";
import { computed, ref } from "vue";

const props = defineProps<{
    appearance?: IAppearance;
}>();

const submitUrl = computed(() =>
    props.appearance
        ? route("app.appearances.update", props.appearance.id)
        : route("app.appearances.store"),
);
const name = ref(props.appearance ? props.appearance.name : "");

function handle() {
    const data = {
        name: name.value,
    };

    if (props.appearance) {
        router.put(submitUrl.value, data);
    } else {
        router.post(submitUrl.value, data);
    }
}
</script>
